import { render, staticRenderFns } from "./RecommendedVideo.vue?vue&type=template&id=30b21348&scoped=true"
import script from "./RecommendedVideo.vue?vue&type=script&lang=js"
export * from "./RecommendedVideo.vue?vue&type=script&lang=js"
import style0 from "./RecommendedVideo.vue?vue&type=style&index=0&id=30b21348&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b21348",
  null
  
)

export default component.exports